import Api from "../../../../service";
import { SET_ERROR, SET_MATCHNEWS, getKey } from "./constants";

const setMatchNews = (data, key) => ({
  type: SET_MATCHNEWS,
  data,
  key,
});

const setError = (data, key) => ({
  type: SET_ERROR,
  data,
  key,
});

export const getMatchNews = (data) => (dispatch) =>
  Api.match
    .getMatchNews(data)
    .then((response) => {
      dispatch(setMatchNews(response, getKey(data)));
      return response;
    })
    .catch((error) => {
      console.error(error);
      dispatch(setError(error, getKey(data)));
    });
